export function formatCurrency(v: string, decimalPlaces: number = 2, showPrefix: boolean = false) {
    let value = parseFloat(v.replaceAll(/\D/g, ""));
    if (!value || Number.isNaN(value)) {
      value = 0;
    }
    const config = {
      minimumFractionDigits: decimalPlaces,
      ...(showPrefix ? {style: "currency", currency: "BRL"} : {})
    }
    const valueFormatted = value.toLocaleString('pt-br', config);
    return valueFormatted; 
}

export function handleMoneyValues(value: string | number) {
  return `R$ ${(value || 0)?.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}